export default "__VITE_ASSET__CrQGwzFI__"